module.exports = __webpack_public_path__ + "img/gdf.85f5f991.jpg";